/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import $ from "jquery";
import Joyride, { ACTIONS, CallBackProps, STATUS, Step } from "react-joyride";

import { applyTheme, expireLogout, getJoyRideScript, logoutClearSession, SessionKeys, showTourAndGuideUtils } from "../../utils/AppUtils";
import { loginBrokerClear, loginClear, logoutBroker, logoutBrokerClear, logoutClear } from "../../redux/auth/actions";
import CONFIG from "../../utils/config";
import Loader from "../../components/Loader/Loader";
import ChatBotComponent from "../../components/ChatBot/ChatBotComponent";
import { setJoyRideReq } from "../../redux/assignCourse/actions";
import { updateTourAndGuideComplete } from "../../redux/reports/actions";
import { userDetailBroker } from "../../redux/user/actions";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Notification from "../../components/Notification";

const HeaderFinwell = ({ showMenu, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const userDetailRes = useSelector((state) => state.user.userBroker);
  const auth = useSelector((state) => state.auth);
  const isLogout = useSelector((state) => state.auth.isLogout);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authLogoutBroker = useSelector((state) => state.auth.authLogoutBroker);
  const userRole = useSelector((state) => state.user.role);
  const joyRideRes = useSelector((state) => state.assignCourse.joyRideRes);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const tourAndGuideRes = useSelector((state) => state.report?.tourAndGuideRes);
  const isLoadingGlobal = useSelector((state) => state.home.isLoadingGlobal);
  //console.log("User roles", userRole);
  const [menuConfig, setMenuConfig] = useState({});
  const [logo, setLogo] = useState("");
  const [isGuest, setIsGuest] = useState(false);
  const [otherRole, setOtherRole] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [joyState, setJoyState] = useState({
    run: false,
  });
  const [showHeaderMenu, setShowHeaderMenu] = useState({
    subscription: true,
  });

  useEffect(() => {
    let timer;
    let IDLE_TIMEOUT = (authBroker?.payload?.user?.session_hour || 1) * 60 * 60 * 1000; // Convert hours to milliseconds
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
       expireLogout();
      }, IDLE_TIMEOUT);
    };

    // Events to track user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    resetTimer(); // start timer

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, []);


  useEffect(()=>{
    setIsLoading(isLoadingGlobal)
  },[isLoadingGlobal])

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      setName(`${authBroker.payload.user.firstname}`);
      setLastName(`${authBroker.payload.user.lastname}`);
      setIsGuest(authBroker.payload.user.role.includes("guest"));
      if (!_.isEmpty(authBroker.payload.user.role)) {
        setMenuConfig(authBroker.payload.user.config);
      } else {
        setMenuConfig({});
      }
      if (
        userRole != "customer" &&
        !authBroker.payload.user.display_subscription_menu &&
        localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
      ) {
        let showSub = _.cloneDeep(showHeaderMenu);
        showSub.subscription = false;
        setShowHeaderMenu(showSub);
      }
    }
  }, [authBroker, userRole]);




  const signOut = () => {
    setIsLoading(true);
    dispatch(
      logoutBroker({
        module: "userlogout",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          impersonate: authBroker?.payload?.user?.is_personate ===1?1:0,
        },
      })
    );
  };

  useEffect(() => {
    //console.log("LOGOUT IS CALLED", authLogoutBroker);
    if (!_.isEmpty(authLogoutBroker)) {

      $("html").css("--color-element-1", CONFIG.COLOR_ELEMENT_1);
      $("html").css("--color-element-2", CONFIG.COLOR_ELEMENT_2);
      if (authBroker.payload.user.apply_theme) {
        if ($("body").hasClass("cus-bro-theme")) {
          $("body").removeClass("cus-bro-theme");
        }
      }
      dispatch(logoutClear());
      dispatch(loginClear());
      // dispatch(setUserPremium(false))
      logoutClearSession();

      dispatch(loginBrokerClear());
      dispatch(logoutBrokerClear());
      setIsLoading(false);
      //   authProvider.logout();
      navigate("/logout", { logout: true });
      
    }
  }, [authLogoutBroker]);

  useEffect(() => {
    if (!_.isEmpty(auth.authBroker)) {
      setOtherRole(auth.authBroker.payload.user.role);
      setLogo(auth.authBroker.payload.user.branding_company_logo);
      let colorElement1 = auth.authBroker.payload.user.branding_primary_color_1;
      let colorElement2 = auth.authBroker.payload.user.branding_primary_color_2;
      if (!colorElement1?.includes("#")) {
        colorElement1 = "#" + colorElement1;
      }
      if (!colorElement2?.includes("#")) {
        colorElement2 = "#" + colorElement2;
      }
      $("html").css("--color-element-1", colorElement1);
      $("html").css("--color-element-2", colorElement2);
      if (auth.authBroker.payload.user.apply_theme) {
        if (!$("body").hasClass("cus-bro-theme")) {
          $("body").addClass("cus-bro-theme");
        }
        const branding = auth.authBroker.payload.user.branding;
        !_.isEmpty(branding) && applyTheme(branding);
      } else {
        if ($("body").hasClass("cus-bro-theme")) {
          $("body").removeClass("cus-bro-theme");
        }
      }
    }
  }, [auth]);

  const completeTourApiReq = () => {
    dispatch(updateTourAndGuideComplete({
      module: "updateTourAndGuideComplete",
      postData: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        complete_tour: 1
      }
    }))
  }

  useEffect(() => {
    if (!_.isEmpty(tourAndGuideRes)) {
      if (tourAndGuideRes?.status === "success") {
        sessionStorage.setItem(SessionKeys.COMPLETE_TOUR, "1");
        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
      }
    }
  }, [tourAndGuideRes]);

  const handleJoyrideCallback = (data) => {
    console.log(data)
    const { status, type, action, index, lifecycle, step } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];


    //when click on intentionally skip button or finish button
    if (type === "tour:end") {
      console.log("tourrr11",status)
      if(status === "finished"){
        completeTourApiReq();
      }
      dispatch(setJoyRideReq({ run: false, stepIndex: 0 }))
      sessionStorage.setItem(SessionKeys.IS_TOUR, "NO")
      if (document.getElementById("idForTour") !== null) {
        document.getElementById("idForTour").classList.remove("taketour")
      }

    }

    //when user click on outside of pop-up
    if (finishedStatuses.includes(status) || action === 'close' || action === 'stop') {
      console.log("tourrr",status)
      dispatch(setJoyRideReq({ run: false, stepIndex: 0 }))
      sessionStorage.setItem(SessionKeys.IS_TOUR, "NO")
      if (document.getElementById("idForTour") !== null) {
        document.getElementById("idForTour").classList.remove("taketour")
      }
      // completeTourApiReq();
    }


  };

  useEffect(() => {
    console.log("joyRideRes:", joyRideRes);
    if (joyRideRes?.run) {
      if (document.getElementById("idForTour") !== null) {
        document.getElementById("idForTour").classList.add("taketour");
      }
    }
    if (!_.isEmpty(joyRideRes)) {
      handleClickStart(joyRideRes);
    }
  }, [joyRideRes]);

  const handleClickStart = (joyRideRes) => {
    console.log("start joyride", joyRideRes);
    // if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
    setJoyState(joyRideRes);
    // }
  };

  return (
    <>
      <Loader start={isLoading} />
      <ChatBotComponent />
      {(
        <Joyride
          callback={handleJoyrideCallback}
          continuous
          hideCloseButton
          run={joyState.run}
          scrollToFirstStep
          showProgress
          showSkipButton
          stepIndex={joyState.stepIndex}
          steps={getJoyRideScript(userRole, isPremiumUser, isGuest)}
          styles={{
            options: {
               primaryColor: 'var(--primary-color, #415385)', // ✅ primary color
                textColor: '#fffffff',
              zIndex: 10000,
              padding: '0.5rem 2rem',
              border: '1px solid var(--primary-color, #415385)'
            },
          }}
        />
      )}

      <nav className="navbar custom-navbar position-fixed top-0 w-100" aria-label="Main navigation">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="logo-sec d-flex gap-3 align-items-center">
         <div
  className="d-none mob-toggle cursor-pointer"
  tabIndex={0}
  onClick={toggleSidebar}
  aria-label="Mobile Toggle"
>
  {/* Hamburger Icon */}
  <svg
    className={`icon hamburger-icon ${showMenu ? "icon-hidden" : ""}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="rgba(71,71,71,1)"
  >
    <path d="M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z" />
  </svg>

  {/* Close Icon */}
  <svg
    className={`icon closeicon ${!showMenu ? "icon-hidden" : ""}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="rgba(0,0,0,1)"
  >
    <path d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z" />
  </svg>
</div>

          <a onClick={() => { navigate("/") }} className="logo-box cursor-pointer" tabIndex={0} aria-label="PwC Envision Home">
            <img src={logo && logo!=="/wp-content/uploads/2022/05/01BG.jpg"?logo:"/images/finwell-img/LogoEnvision.svg"} alt="PwC Envision logo" role="img" />
          </a>
          </div>
          <div className="d-flex align-items-center gap-2 search-area cursor-pointer" role="search" aria-label="Site search" tabIndex={0} onClick={()=>navigate('/global-search')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.592 9.872L16 15.28L15.28 16L9.872 10.576C9.34933 11.0347 8.752 11.3867 8.08 11.632C7.41867 11.8773 6.72533 12 6 12C4.912 12 3.904 11.728 2.976 11.184C2.06933 10.6507 1.34933 9.93067 0.816 9.024C0.272 8.096 0 7.088 0 6C0 4.912 0.272 3.904 0.816 2.976C1.34933 2.06933 2.06933 1.34933 2.976 0.816C3.904 0.272 4.912 0 6 0C7.088 0 8.096 0.272 9.024 0.816C9.93067 1.34933 10.6507 2.06933 11.184 2.976C11.728 3.904 12 4.912 12 6C12 6.72533 11.8773 7.41867 11.632 8.08C11.3867 8.74133 11.04 9.33867 10.592 9.872ZM6.016 11.008C6.92267 11.008 7.76 10.7787 8.528 10.32C9.28533 9.88267 9.88267 9.28533 10.32 8.528C10.7787 7.76 11.008 6.92267 11.008 6.016C11.008 5.10933 10.7787 4.26667 10.32 3.488C9.88267 2.73067 9.28533 2.13333 8.528 1.696C7.76 1.23733 6.92267 1.008 6.016 1.008C5.10933 1.008 4.26667 1.23733 3.488 1.696C2.73067 2.13333 2.13333 2.73067 1.696 3.488C1.23733 4.26667 1.008 5.10933 1.008 6.016C1.008 6.92267 1.23733 7.76 1.696 8.528C2.13333 9.28533 2.73067 9.88267 3.488 10.32C4.26667 10.7787 5.10933 11.008 6.016 11.008Z" fill="#474747" />
            </svg>
            <span className="d-none d-md-block">Search</span>
          </div>
          <div className="d-flex align-items-center gap-3">
            {true ? <Notification /> :<button className="link cursor-pointer btn btn-link" tabIndex={0} aria-label="Notifications">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 16C8.81067 16 9.57867 15.8187 10.304 15.456C10.9973 15.104 11.5893 14.6187 12.08 14H3.936C4.416 14.6187 5.00267 15.104 5.696 15.456C6.42133 15.8187 7.18933 16 8 16ZM15.408 9.008L14.208 8.448L12.448 3.648C12.3733 3.456 12.2453 3.30133 12.064 3.184C11.8933 3.056 11.7067 2.992 11.504 2.992H11.008C11.008 2.448 10.8693 1.94667 10.592 1.488C10.3253 1.02933 9.96267 0.666667 9.504 0.4C9.04533 0.133333 8.544 0 8 0C7.456 0 6.95467 0.133333 6.496 0.4C6.03733 0.666667 5.67467 1.02933 5.408 1.488C5.14133 1.94667 5.008 2.448 5.008 2.992H4.496C4.29333 2.992 4.10133 3.056 3.92 3.184C3.74933 3.30133 3.62667 3.456 3.552 3.648L1.792 8.448L0.592 9.008C0.410667 9.08267 0.266667 9.20533 0.16 9.376C0.0533333 9.536 0 9.712 0 9.904V12H16V9.904C16 9.712 15.9467 9.536 15.84 9.376C15.7333 9.20533 15.5893 9.08267 15.408 9.008ZM7.008 2.992C7.008 2.71467 7.104 2.48 7.296 2.288C7.49867 2.096 7.73333 2 8 2C8.27733 2 8.512 2.096 8.704 2.288C8.90667 2.48 9.008 2.71467 9.008 2.992H7.008Z" fill="#415385" />
              </svg>
            </button>}
            {/* <button className="link cursor-pointer btn btn-link" aria-label="Settings">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10.384 0.23999C10.5013 0.23999 10.6133 0.27199 10.72 0.33599L13.28 1.80799C13.4187 1.89332 13.5147 2.00532 13.568 2.14399C13.6213 2.28266 13.6267 2.42666 13.584 2.57599L13.168 4.06399C13.488 4.47999 13.7653 4.95999 14 5.50399L15.488 5.87199C15.6373 5.91466 15.76 5.99466 15.856 6.11199C15.952 6.22932 16 6.36266 16 6.51199V9.47199C16 9.62132 15.952 9.75999 15.856 9.88799C15.76 10.0053 15.6373 10.0853 15.488 10.128L14 10.496C13.7653 11.0293 13.488 11.5093 13.168 11.936L13.584 13.424C13.6267 13.5627 13.6213 13.7013 13.568 13.84C13.5147 13.9893 13.4187 14.1067 13.28 14.192L10.72 15.664C10.6133 15.728 10.5013 15.76 10.384 15.76C10.2027 15.76 10.0427 15.6907 9.904 15.552L8.832 14.432C8.46933 14.4747 8.192 14.496 8 14.496C7.808 14.496 7.53067 14.4747 7.168 14.432L6.096 15.552C5.95733 15.6907 5.79733 15.76 5.616 15.76C5.50933 15.76 5.39733 15.728 5.28 15.664L2.72 14.192C2.58133 14.1067 2.48533 13.9893 2.432 13.84C2.37867 13.7013 2.37333 13.5627 2.416 13.424L2.832 11.936C2.512 11.5093 2.23467 11.0293 2 10.496L0.512 10.128C0.362667 10.0853 0.24 10.0053 0.144 9.88799C0.048 9.75999 0 9.62132 0 9.47199V6.51199C0 6.36266 0.048 6.22932 0.144 6.11199C0.24 5.99466 0.362667 5.91466 0.512 5.87199L2 5.50399C2.23467 4.95999 2.512 4.47999 2.832 4.06399L2.416 2.57599C2.37333 2.42666 2.37867 2.28266 2.432 2.14399C2.48533 2.00532 2.58133 1.89332 2.72 1.80799L5.28 0.33599C5.39733 0.27199 5.50933 0.23999 5.616 0.23999C5.808 0.23999 5.968 0.309324 6.096 0.44799L7.168 1.55199C7.44533 1.51999 7.72267 1.50399 8 1.50399C8.288 1.50399 8.56533 1.51999 8.832 1.55199L9.904 0.44799C10.032 0.309324 10.192 0.23999 10.384 0.23999ZM10.448 1.32799L9.552 2.25599L9.2 2.60799L8.704 2.54399C8.43733 2.51199 8.20267 2.49599 8 2.49599C7.808 2.49599 7.57333 2.51199 7.296 2.54399L6.8 2.60799L6.448 2.25599L5.552 1.32799L3.44 2.54399L3.792 3.79199L3.936 4.27199L3.632 4.67199C3.32267 5.07732 3.088 5.48266 2.928 5.88799L2.736 6.35199L2.24 6.46399L1.008 6.78399V9.21599L2.736 9.64799L2.928 10.112C3.10933 10.5387 3.344 10.944 3.632 11.328L3.936 11.728L3.792 12.208L3.44 13.456L5.552 14.672L6.8 13.376L7.296 13.44C7.57333 13.472 7.808 13.488 8 13.488C8.20267 13.488 8.43733 13.472 8.704 13.44L9.2 13.376L10.448 14.672L12.56 13.456L12.208 12.208L12.064 11.728L12.368 11.328C12.656 10.944 12.8907 10.5387 13.072 10.112L13.264 9.64799L13.76 9.51999L15.008 9.21599V6.78399L13.76 6.46399L13.264 6.35199L13.072 5.88799C12.912 5.48266 12.6773 5.07732 12.368 4.67199L12.064 4.27199L12.208 3.79199L12.56 2.54399L10.448 1.32799ZM8 10.496C7.552 10.496 7.136 10.384 6.752 10.16C6.368 9.93599 6.064 9.63199 5.84 9.24799C5.616 8.86399 5.504 8.44799 5.504 7.99999C5.504 7.55199 5.616 7.13599 5.84 6.75199C6.064 6.36799 6.368 6.06399 6.752 5.83999C7.136 5.61599 7.552 5.50399 8 5.50399C8.448 5.50399 8.864 5.61599 9.248 5.83999C9.632 6.06399 9.936 6.36799 10.16 6.75199C10.384 7.13599 10.496 7.55199 10.496 7.99999C10.496 8.44799 10.384 8.86399 10.16 9.24799C9.936 9.63199 9.632 9.93599 9.248 10.16C8.864 10.384 8.448 10.496 8 10.496ZM8 6.49599C7.584 6.49599 7.22667 6.64532 6.928 6.94399C6.64 7.23199 6.496 7.58399 6.496 7.99999C6.496 8.26666 6.56 8.51732 6.688 8.75199C6.82667 8.97599 7.01333 9.15732 7.248 9.29599C7.48267 9.43466 7.73333 9.50399 8 9.50399C8.26667 9.50399 8.51733 9.43466 8.752 9.29599C8.98667 9.15732 9.168 8.97599 9.296 8.75199C9.43467 8.51732 9.504 8.26666 9.504 7.99999C9.504 7.58399 9.35467 7.23199 9.056 6.94399C8.768 6.64532 8.416 6.49599 8 6.49599Z" fill="#474747" />
              </svg>
            </button> */}
                  <NavDropdown
                 
                    id="nav-dropdown-dark-example"
                    title={
                       userDetailRes?.payload?.payload?.profile_img !== undefined &&
                userDetailRes?.payload?.payload?.profile_img !== ""?<div className="profile-img-box">
            <img
              src={ userDetailRes?.payload?.payload?.profile_img
              }
            />
            </div>:
                    <span>
                      {name
                      ? name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()
                      : ""}
                    {lastName
                      ? lastName
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()
                      : ""}
                  </span>
              }
              className="avatar-circle border-0 cursor-pointer " aria-label="User menu" tabIndex={0}
            >
              <li>
                <button className="dropdown-item" type="button" onClick={() => {
                  navigate(
                    `/profile/edit?section=edit&tab=1&user_id=${authBroker.payload.user.user_id}`
                  );
                }}>
                  Profile
                </button>
              </li>
               
              <li>
                <button className="dropdown-item" type="button" onClick={() => {
                  navigate("/home");
                  setTimeout(() => {
                    showTourAndGuideUtils(dispatch);
                  }, 1000);
                }}>
                  Take the tour
                </button>
              </li>
              <li>
                <button className="dropdown-item" type="button" onClick={signOut}>
                  Logout
                </button>
              </li>

            </NavDropdown>

            {/* End Profile Dropdown */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderFinwell;
